import { GetChannelsRequest, GetUsersRequest } from 'redux/reducers/moderation/types';
import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { IModerationApi } from './types';

export const moderation: IModerationApi = {
  getCounters: () =>
    http.post(endpoint.moderation.GET_REPORTS_COUNTERS, {}).then((response) => response.data),

  getReports: (data) =>
    http.post(endpoint.moderation.GET_REPORTS, data).then((response) => response.data),

  getFlags: () => http.get(endpoint.moderation.GET_FLAGS).then((response) => response.data),

  approve: (data) => http.post(endpoint.moderation.APPROVE, data).then((response) => response.data),

  reject: (data) => http.post(endpoint.moderation.REJECT, data).then((response) => response.data),

  topChannels: () =>
    http.post(endpoint.moderation.GET_TOP_CHANNELS).then((response) => response.data),

  topUsers: () => http.post(endpoint.moderation.GET_TOP_USERS).then((response) => response.data),

  getUsers: (payload: GetUsersRequest) =>
    http.post(endpoint.moderation.GET_USERS, payload).then((response) => response.data),

  getChannels: (payload: GetChannelsRequest) =>
    http.post(endpoint.moderation.GET_CHANNELS, payload).then((response) => response.data),
};
